import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter } from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { CuentasPorCobrarService } from '../../../services/cuentas-por-cobrar.service';
import {HelpersService} from "../../../services/tools/helpers.service";
import { CuentasPorPagarService } from '../../../services/cuentas-por-pagar.service';

@Component({
  selector: 'app-modal-eliminar-cxp',
  templateUrl: './modal-eliminar-cxp.component.html',
  styleUrls: ['./modal-eliminar-cxp.component.scss']
})
export class ModalEliminarCXPComponent implements OnInit {

  public modal: any = null;
  public errors: any = {};
  
  //Modelos
  public cuentaPorPagar: any = {};

  //Helpers
  public eliminando: boolean = null;

  @ViewChild('modalEliminarCXP') private content: TemplateRef<any>;
  @Output() public cuentaEliminada : EventEmitter<void> = new EventEmitter;

  constructor(public cuentas_por_cobrar_service:CuentasPorCobrarService, 
    private modalService: NgbModal,
    private helperService: HelpersService,
    private cxpService: CuentasPorPagarService) { }

  ngOnInit() {
  }

  public openModal(cuentaPorPagar: any){
    this.modal = this.modalService.open(this.content, { });
    this.cuentaPorPagar = cuentaPorPagar;
  }

  public closeModal() {
    this.modal.close();
  }

  public eliminarCuenta(){
        this.eliminando = true;

        this.cxpService.eliminarCuentaPorPagar(this.cuentaPorPagar.id_cuenta_por_pagar).subscribe(
            (response)=>
            {
                this.eliminando = false;
                this.cuentaEliminada.emit();
                this.modal.close();
                
                this.helperService.notification('Cuenta eliminada', 'Se ha eliminado exitosamente la cuenta por pagar', 'success');

            }, error =>
            {
                this.eliminando = false;
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);
                if(error.status == 400) {
                    alert("ERROR: "+JSON.stringify(error));
                }
            }
        );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/reporte-cxp/modal-eliminar-cxp/modal-eliminar-cxp.component.ts